import React from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import AdvanceForm from "./AdvancedSalaryForm";
import BackButton from "../../../components/BackButton/BackButton";

const AdvancedSalary = () => {
  return (
    <Container maxWidth="lg">
      <Grid
        container
        spacing={4}
        sx={{
          "& > .MuiGrid-item:last-of-type": { pt: "20px !important" },
        }}
      >
        <Grid xs={12}>
          <Box sx={{ px: 4, pt: 4 }}>
            <Stack alignItems={{ xs: "flex-start" }} >
              <BackButton sx={{ mb: { xs: 5, sm: 5 } }} />
              <Typography variant="h3">Advanced Salary</Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} md={12}>
          <AdvanceForm />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdvancedSalary;
